const getOrgLogoUrl = (key) => {
  const awsBaseUrl = process.env.REACT_APP_AWS_BASE_URL.replace(/\/+$/, '');

  if (!key) return undefined;
  return `${awsBaseUrl}/${key}`;
};

export default getOrgLogoUrl;
